<template>
	<main class="swipekit-button-new" :data-selection="computedSelection">
		<Info
			v-if="computedTempAd && mode === 'extension'"
			:ad="computedTempAd"
		></Info>
		<button
			:class="[
				{ 'has-boards': selected.length > 0 },
				{ library: library === true },
				{ active: saving === true },
				{ error: !!errorMessage },
				{ saved: saved },
			]"
			@click="onClick"
		>
			<span class="counter" v-if="selected && selected.length > 0 && !saved">
				{{ selected.length }}
			</span>
			<span>
				{{ buttonText }}
			</span>
			<svg
				v-if="!saved"
				@click="toggleList"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M6 2.75C5.58579 2.75 5.25 3.08579 5.25 3.5C5.25 3.91421 5.58579 4.25 6 4.25H18C18.4142 4.25 18.75 3.91421 18.75 3.5C18.75 3.08579 18.4142 2.75 18 2.75H6ZM3.25 6C3.25 5.58579 3.58579 5.25 4 5.25H20C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75H4C3.58579 6.75 3.25 6.41421 3.25 6ZM1 10C1 8.89543 1.89543 8 3 8H21C22.1046 8 23 8.89543 23 10V22C23 23.1046 22.1046 24 21 24H3C1.89543 24 1 23.1046 1 22V10Z"
					fill="white"
				/>
			</svg>
			<svg
				v-if="saved && tempBlock"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM16 9C16 8.44772 15.5523 8 15 8H10C9.44771 8 9 8.44772 9 9C9 9.55228 9.44771 10 10 10H12.5858L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L14 11.4142V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V9Z"
					fill="currentColor"
				/>
			</svg>
		</button>
		<List
			:mode="mode"
			:boards="boards"
			:folders="folders"
			:recentBoardIds="recentBoardIds"
			:loaded="loaded"
			ref="list"
			@clickOutside="closeList"
			@createBoard="loadData"
			:baseUrl="baseurl"
			:selected="selected"
			@change="onChange"
			:active="listActive"
		></List>
	</main>
</template>

<script>
import Info from './info';
import List from './list';
import saveAd from './save-ad.js';

import utils from './utils';

import loadBoards from './load-boards';
import loadFolders from './load-folders';
import loadRecentBoardIds from './recent-board-ids';

var logs = [];

export default {
	components: {
		Info,
		List,
	},

	props: {
		token: {
			type: String,
			default: '',
		},
		baseurl: {
			type: String,
			default: 'http://localhost:4000',
		},
		fbsaved: {},
		error: {},
		type: {
			default: 'facebook',
		},
		mode: {
			default: 'extension',
		},
		blockId: {},

		library: {
			type: Boolean,
			default: false,
		},

		ad: {},
	},

	data: function () {
		return {
			saved: false,
			saving: false,
			errorMessage: '',
			listActive: false,

			loaded: false,

			selected: [],

			boards: [],
			folders: [],
			recentBoardIds: [],

			tempData: null,

			tempBlock: null,

			processing: false,
		};
	},

	watch: {
		error: {
			handler: function () {
				if (this.error) {
					this.errorMessage = this.error;
				}
			},
			immediate: true,
		},
		fbsaved: {
			handler: function () {
				if (this.fbsaved) {
					this.saved = true;
					this.checkForId();
				}
			},
			immediate: true,
		},
		currentBoards: function () {
			this.loadData(true);
		},
		currentFolders: function () {
			this.loadData(true);
		},
	},

	computed: {
		currentBoards: function () {
			if (this.mode === 'extension') {
				return [];
			}
			return this.$store.getters['boards/filtered'];
		},
		currentFolders: function () {
			if (this.mode === 'extension') {
				return [];
			}
			return this.$store.getters['folders/filtered'];
		},
		computedTempAd: function () {
			if (!this.tempData) {
				return;
			}
			if (this.type !== 'facebook') {
				return;
			}

			let ad = utils.computeTempAd(this.tempData);

			return ad;
		},
		buttonText: function () {
			if (this.processing) {
				return `Updating`;
			}
			if (this.library) {
				let s = 's';
				if (this.selected.length === 1) {
					s = '';
				}
				return `${this.selected.length} board${s}`;
			}

			if (this.errorMessage) {
				return this.errorMessage;
			}

			if (this.saving) {
				return `Saving...`;
			}

			if (this.saved) {
				if (this.tempBlock) {
					return `Saved, view in app`;
				}
				return `Saved`;
			}

			if (this.selected && this.selected.length) {
				let s = 's';
				if (this.selected.length === 1) {
					s = '';
				}
				return `Save in ${this.selected.length} board${s}`;
			}

			return `Save`;
		},
		computedSelection: function () {
			return JSON.stringify(this.selected);
		},
	},

	methods: {
		async checkForId() {
			if (this.mode !== 'extension') {
				return;
			}

			let target = this.$parent.parentElement;
			let blockId = await utils.checkForId(target, this.baseurl);

			if (blockId) {
				this.tempBlock = {
					id: blockId,
				};
			}
		},
		onBoardCreated: function () {
			this.listActive = true;

			this.$nextTick(() => {
				this.$refs.list.refresh();
			});
		},
		onClick: async function (e) {
			logs.push('saving ad');

			if (this.saved && this.tempBlock) {
				logs.push('ad already saved, redirecting to dashboard');
				utils.redirectToDashboard(this.tempBlock);
				return;
			}

			if (this.saved) {
				logs.push('ad already saved, redirecting to dashboard');
				return;
			}

			let selected = this.selected;

			let target = e.target;
			let isSvg = target.closest('svg');
			if (isSvg) {
				logs.push('clicked on svg, returning');
				return;
			}

			if (selected.length > 0) {
				await loadRecentBoardIds.set(this.mode, selected);
			}

			// update boards instead
			if (this.library && this.ad) {
				this.processing = true;
				this.listActive = false;

				let selected = this.selected;
				let form = {
					id: this.ad.id,
					boards: selected,
				};
				const data = await this.$store.dispatch('ads/update', form);
				if (data) {
					this.$store.dispatch('message/sendMessage', {
						message: `Ad updated`,
						timer: 1500,
						status: 'success',
					});
				}
				this.processing = false;

				return;
			}

			this.listActive = false;
			this.saving = true;

			let response = null;

			logs.push(`attempting to save ads, ${selected.length} boards selected`);

			try {
				if (this.mode !== 'extension') {
					response = await saveAd.saveMultiplayerAd(
						{
							blockId: this.blockId,
							selected,
							$store: this.$store,
						},
						logs
					);

					this.saved = true;
				} else {
					let target = this.$parent.parentElement;
					response = await saveAd.saveExtensionAd(
						{
							type: this.type,
							target,
							selected,
							baseUrl: this.baseurl,
						},
						logs
					);
					this.saved = true;
				}
			} catch (err) {
				console.log(err);
				this.errorMessage = err;
			}
			logs.push(`Save ad completed`);

			if (this.saved && response && response.data && response.data.id) {
				logs.push(`TempBlock retrieved`);
				this.tempBlock = response.data;
			}
			this.saving = false;
			this.listActive = false;

			if (!this.saved) {
				// send the logs and the errors to ops
			} else {
			}

			console.log(logs);
			logs = [];
		},
		onChange: function (selected) {
			this.selected = selected;
		},
		toggleList: function () {
			setTimeout(() => {
				if (!this.listActive) {
					this.loadData();
				}
				this.listActive = !this.listActive;
			}, 1);
		},
		closeList() {
			this.listActive = false;
		},
		handleKeyPress(event) {
			if (event.key === 'Escape' || event.key === 'Esc') {
				this.listActive = false;
			}
		},
		async loadData(refresh = false) {
			if (this.mode !== 'extension') {
				await this.loadWebappData();
				this.loaded = true;
				return;
			}

			if (this.loaded && !refresh) {
				return;
			}

			let baseurl = this.baseurl;
			let token = localStorage.getItem('um/token');

			try {
				token = JSON.parse(token);
			} catch (err) {
				token = 'invalid';
			}

			let boards = await loadBoards(baseurl, token);
			let folders = await loadFolders(baseurl, token);
			let recentBoardIds = await loadRecentBoardIds.get(this.mode);

			this.boards = boards;
			this.folders = folders;
			this.recentBoardIds = recentBoardIds;

			this.loaded = true;
		},
		async loadWebappData() {
			this.boards = this.$store.getters['boards/filtered'];
			this.folders = this.$store.getters['folders/filtered'];
			this.recentBoardIds = this.$store.getters['boards/recentBoardIds'];
		},
	},

	created: function () {
		if (this.library && this.ad) {
			this.selected = this.ad.boards.map((board) => {
				return board;
			});
		}
	},

	mounted: function () {
		document.body.addEventListener('keydown', this.handleKeyPress);
	},
	beforeDestroy() {
		document.body.removeEventListener('keydown', this.handleKeyPress);
	},
};
</script>

<style lang="scss">
swipekit-picker {
	box-sizing: border-box;

	* {
		box-sizing: border-box;
	}
}
.c-picker {
	--p: 245;

	position: relative;
	margin-bottom: 8px;
	display: grid;
	grid-template-columns: 1fr 36px;
	width: 100%;
	height: 35.5px;
	border-radius: 6px;
	border: #dfdfdf solid 1px;
	text-align: center;

	&__left {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		user-select: none;
		cursor: pointer;
		background-color: var(--color-bg-1);
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px;

		&.active {
			color: #665bdc;
		}
	}

	&__right {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		border-left: #dfdfdf solid 1px;
		background-color: var(--color-bg-1);
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px;
		cursor: pointer;

		svg {
			color: #665bdc;
		}
	}
}

.swipekit-button-new {
	position: relative;
	padding: 5px;
	background-color: hsl(var(--s2), 60%, 97.5%);
	border-bottom-left-radius: var(--item-border-radius);
	border-bottom-right-radius: var(--item-border-radius);

	> button {
		position: relative;
		-webkit-appearance: none;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 33.5px;
		background-color: #665bdc;
		color: var(--color-button-font);
		font-weight: 600;
		font-size: 13px;
		border: none;
		text-align: center;
		padding: 4px 10px;
		border-radius: 6px;
		transition: all 80ms linear;
		font-family: 'Termina';
		text-transform: uppercase;
		user-select: none;
		cursor: pointer;
		line-height: 1.2;
		&:hover {
			color: var(--color-button-font);
			background-color: #665bdc !important;
			cursor: pointer;

			box-shadow: inset 0 1px 0px rgba(255, 255, 255, 0.2),
				inset 0 -1px 0px rgba(0, 0, 0, 0.2), 0 1px 8px rgba(0, 0, 0, 0.075);
		}

		&:active {
			box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.2),
				inset 0 1px 6px rgba(0, 0, 0, 0.15), 0 -1px 2px rgba(0, 0, 0, 0.1);
		}

		&.active {
			color: var(--color-button-font);
			background-color: #665bdc !important;
			cursor: not-allowed;
			pointer-events: none;

			&:after {
				content: '';
				position: absolute;
				top: 9px;
				left: 10px;
				width: 16px;
				height: 16px;
				border: 2px solid #fff;
				border-bottom-color: transparent;
				border-radius: 50%;
				display: inline-block;
				box-sizing: border-box;
				animation: rotation 1s linear infinite;
			}

			.counter {
				display: none;
			}
		}

		&.saved {
			background-color: #41a269 !important;
			box-shadow: none;

			&:hover {
				cursor: pointer;
				box-shadow: inset 0 1px 0px rgba(255, 255, 255, 0.2),
					inset 0 -1px 0px rgba(0, 0, 0, 0.2), 0 1px 8px rgba(0, 0, 0, 0.075);
			}

			&:active {
				box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.2),
					inset 0 1px 6px rgba(0, 0, 0, 0.15), 0 -1px 2px rgba(0, 0, 0, 0.1);
			}
		}

		&.error {
			background-color: var(--color-danger);
			pointer-events: none;
			font-size: 11px;
			font-style: initial;

			&:hover {
				background-color: var(--color-danger);
			}
		}

		&.library {
			background-color: hsl(var(--p), 10%, 55%);
			&.has-boards {
				background-color: #665bdc;
			}
		}

		> svg {
			position: absolute;
			right: 0;
			top: 0;
			width: 33.5px;
			height: 33.5px;
			padding: 6px;
			border-left: solid 1px rgba(0, 0, 0, 0.125);
			transition: background-color 60ms linear;

			&:hover {
				background-color: rgba(255, 255, 255, 0.2);
			}
		}

		.counter {
			position: absolute;
			left: 5px;
			top: 5px;
			width: 24px;
			height: 24px;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
			background-color: #fff;
			color: #665bdc;
			font-family: var(--font-family);
			border-radius: 99px;
		}
	}

	input {
		-webkit-appearance: none;
		appearance: none;
		display: block;
		border: none;
		width: 100%;
		height: 100%;
		padding: 4px 8px;
		padding-right: 32px;
		background-color: #ddd;
		font-size: 14px;
		border-radius: 6px;
		//border-top-left-radius: 6px;
		//border-bottom-left-radius: 6px;

		&:focus {
			outline: none;
			box-shadow: 0 0 0 2px hsla(240, 100%, 60%, 0.5);
		}
	}
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
